import React from 'react';
import { PlusIcon, SettingsIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
interface CoffeeHeaderProps {
  onCreateClick: () => void;
}
const CoffeeHeader: React.FC<CoffeeHeaderProps> = ({
  onCreateClick
}) => {
  return <div className="flex flex-col md:flex-row md:items-center md:justify-between" data-id="element-165">
      <div className="mb-4 md:mb-0" data-id="element-166">
        <h1 className="text-2xl font-semibold text-gray-800" data-id="element-167">EIIS Coffee</h1>
      </div>
      <div className="flex space-x-3" data-id="element-168">
        <Link to="/coffee/my-events" className="flex items-center justify-center py-2 px-4 bg-white border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-169">
          <SettingsIcon size={18} className="mr-2" data-id="element-170" />
          Gestisci
        </Link>
        <button onClick={onCreateClick} className="flex items-center justify-center py-2 px-4 bg-custom-green text-white rounded-lg hover:bg-custom-green/90 transition-colors" data-id="element-171">
          <PlusIcon size={18} className="mr-2" data-id="element-172" />
          Nuovo
        </button>
      </div>
    </div>;
};
export default CoffeeHeader;